import React from 'react';

const ArchiveReasons = ({ onChange, options, reason }) => {

    const handleChange = (option) => {
        onChange(option);
    }
    return (
        <>
            <label className="label">Reason to archive</label>
            <div className="columns is-multiline">
                {options.map(option =>
                    <div className="column is-4" key={option.label}>
                        <button
                            type="button"
                            className={`button is-fullwidth ${option.value === reason ? "is-link" : ""}`}
                            onClick={() => handleChange(option.value)}>{option.label}
                        </button>
                    </div>
                )}
            </div>
        </>
    );
}
export default ArchiveReasons;
